const $$splitComponentImporter = () => import('/app/apps/web/src/routes/unsubscribe/notifications.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickString } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
interface UnsubscribeSearch {
  token?: string;
}
export const Route = createFileRoute("/unsubscribe/notifications")({
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "globals.unsubscribe"
    });
    return {
      meta: buildPrivatePageMetaTags(t("title"))
    };
  },
  validateSearch: (search: Record<string, unknown>): UnsubscribeSearch => ({
    token: pickString(search.token as string | string[] | undefined)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});